import React from 'react'
import { useParams } from 'react-router-dom'
import { projectsData } from '../constants/projectsData'

export default function ProjectShowcase() {
  const { id } = useParams()
  const projectData = projectsData[id]

return (
    <div className="mx-auto max-w-4xl mt-24">
      <div className="flex flex-col lg:flex-row gap-12">

        {/* Left - Media */}
        <div className="lg:w-2/3 space-y-6">

        {/* Video */}
        {projectData.video_url && (
            <iframe
                width="100%"
                height="auto"
                src={`${projectData.video_url}`}
                // title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; encrypted-media; gyroscope; picture-in-picture;"
                allowFullScreen
                className="w-full aspect-video"
            />
        )}

        {/* Images */}
        {Array.from({ length: projectData.imageCount }, (_, i) => {
            const imageNumber = i + 1
            const imagePath = `/img/projects/${projectData.category}/${projectData.title}/${imageNumber}.webp`
            
            return (
            <img 
                key={i}
                src={imagePath} 
                alt={`${projectData.title} - ${imageNumber}`}
                className="w-full h-auto object-cover"
            />
            )
        })}
        </div>


        {/* Right - Project Info */}
        <div className="lg:w-1/3">
          <h1 className="text-3xl uppercase font-bold mb-2">{projectData.title}</h1>
          <p className="text-sm mb-8 bg-white bg-opacity-10 px-3 py-2 rounded-2xl w-fit h-fit">{projectData.category}</p>

          <div className="space-y-4">

            <div>
              <p className="text-xs uppercase font-semibold text-gray-600 mb-2">{projectData.role}</p>
              <p className="text-lg">Ronnee Swenton</p>
            </div>

            {projectData.director && (
              <div>
                <p className="text-xs uppercase font-semibold text-gray-600 mb-2">Director</p>
                <p className="text-lg">{projectData.director}</p>
              </div>
            )}
            {projectData.client && (
              <div>
                <p className="text-xs uppercase font-semibold text-gray-600 mb-2">Client</p>
                <p className="text-lg">{projectData.client}</p>
              </div>
            )}
            {projectData.starring && (
              <div>
                <p className="text-xs uppercase font-semibold text-gray-600 mb-2">Starring</p>
                <p className="text-sm leading-relaxed">{projectData.starring}</p>
              </div>
            )}
            {projectData.producer && (
              <div>
                <p className="text-xs uppercase font-semibold text-gray-600 mb-2">Producer</p>
                <p className="text-lg">{projectData.producer}</p>
              </div>
            )}
            {projectData.description && (
              <div>
                <p className="text-xs uppercase font-semibold text-gray-600 mb-2">Description</p>
                <p className="text-sm leading-relaxed">{projectData.description}</p>
              </div>
            )}
            {projectData.awards && (
              <div>
                <p className="text-xs uppercase font-semibold text-gray-600 mb-2">Awards</p>
                <p className="text-xs leading-relaxed">{projectData.awards}</p>
              </div>
            )}
          </div>
        </div>

      </div>
    </div>
  )
}

